import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

/* EN */
import enSidebar from "./locales/en/Sidebar.json";
import enOrders from "./locales/en/OrdersPage.json";
import enFinance from "./locales/en/FinanceReport.json";
import enCalendar from "./locales/en/CalendarPage.json"
import enRightBar from "./locales/en/RightBar.json"
import enClientsPage from "./locales/en/ClientsPage.json"
import enSuppliersPage from "./locales/en/SuppliersPage.json"
import enProductsPage from "./locales/en/ProductsPage.json"
import enExpeditorsPage from "./locales/en/ExpeditorsPage.json"
import enUI from "./locales/en/ui.json"
import enOrderPage from "./locales/en/OrdersPage.json"



/* RU */
import ruSidebar from "./locales/ru/Sidebar.json";
import ruOrders from "./locales/ru/OrdersPage.json";
import ruFinance from "./locales/ru/FinanceReport.json";
import ruCalendar from "./locales/ru/CalendarPage.json"
import ruRightBar from "./locales/ru/RightBar.json"
import ruClientsPage from "./locales/ru/ClientsPage.json"
import ruSuppliersPage from "./locales/ru/SuppliersPage.json"
import ruProductsPage from "./locales/ru/ProductsPage.json"
import ruExpeditorsPage from "./locales/ru/ExpeditorsPage.json"
import ruUI from "./locales/ru/ui.json"
import ruOrderPage from "./locales/ru/OrdersPage.json"



/* CN */
import cnSidebar from "./locales/zh/Sidebar.json";
import cnOrders from "./locales/zh/OrdersPage.json";
import cnFinance from "./locales/zh/FinanceReport.json";
import cnCalendar from "./locales/zh/CalendarPage.json"
import cnRightBar from "./locales/zh/RightBar.json"
import cnClientsPage from "./locales/zh/ClientsPage.json"
import cnSuppliersPage from "./locales/zh/SuppliersPage.json"
import cnProductsPage from "./locales/zh/ProductsPage.json"
import cnExpeditorsPage from "./locales/zh/ExpeditorsPage.json"
import cnUI from "./locales/zh/ui.json"
import cnOrderPage from "./locales/zh/OrdersPage.json"


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        Sidebar: enSidebar,
        OrdersPage: enOrders,
        FinanceReport: enFinance,
        CalendarPage: enCalendar, 
        RightBar: enRightBar,
        ClientsPage: enClientsPage,
        SuppliersPage: enSuppliersPage,
        ProductsPage: enProductsPage,
        ExpeditorsPage: enExpeditorsPage,
        UI: enUI,
        OrdersPage: enOrderPage,
      },
      ru: {
        Sidebar: ruSidebar,
        OrdersPage: ruOrders,
        FinanceReport: ruFinance,
        CalendarPage: ruCalendar, 
        RightBar: ruRightBar,
        ClientsPage: ruClientsPage,
        SuppliersPage: ruSuppliersPage,
        ProductsPage: ruProductsPage,
        ExpeditorsPage: ruExpeditorsPage,
        UI: ruUI,
        OrdersPage: ruOrderPage,
      },
      zh: {
        Sidebar: cnSidebar,
        OrdersPage: cnOrders,
        FinanceReport: cnFinance,
        CalendarPage: cnCalendar, 
        RightBar: cnRightBar,
        ClientsPage: cnClientsPage,
        SuppliersPage: cnSuppliersPage,
        ProductsPage: cnProductsPage,
        ExpeditorsPage: cnExpeditorsPage,
        UI: cnUI,
        OrdersPage: cnOrderPage,
      },
    },

    // 🔥 КЛЮЧЕВОЕ ИСПРАВЛЕНИЕ
    supportedLngs: ["en", "ru", "zh"],

    // превращает zh-CN / zh-TW → zh
    load: "languageOnly",

    fallbackLng: "ru",

    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;